<template>
    <div class="radiobutton-wrapper">
        <slot></slot>
    </div>
</template>

<script>
    import { EventBus } from '../eventbus';

    export default {
        props: ['name'],

        data() {
            return {
                radiobuttonArray: [],
            }
        },

        methods: {

        },

        created() {
            EventBus.$on('registerRadiobutton', data => {
                if (this.name == data.name) {
                    var temp = {'value': data.value, 'status': data.status};
                    this.radiobuttonArray.push(temp);
                }
            });
            EventBus.$on('radiobuttonStatusChanged', data => {
                if (this.name == data.name) {
                    this.radiobuttonArray.forEach(function(radiobutton, index) {
                        if (radiobutton.status == true) {
                            this[index].status = false;
                        }
                        if (radiobutton.value == data.value) {
                            this[index].status = data.status;
                        }
                    }, this.radiobuttonArray);
                    // Emit stuff, adds value if status is true, if false (meaning it is deactivated) we send null
                    EventBus.$emit('radiobuttonsChanged', {'name': this.name, 'data': this.radiobuttonArray, 'value': data.status ? data.value : null});
                }
            });
        }
    }
</script>
